import { Instagram } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHead } from "./SectionHead";

// Sezione "Ultimi reel" alimentata da un widget SnapWidget (gratuito).
// L'ID del widget si imposta dal pannello admin (/admin -> Impostazioni sito -> Instagram)
// senza bisogno di intervento tecnico. Se non è impostato, la sezione non viene mostrata.
export const InstagramReels = ({ widgetId, instagramUrl }) => {
  if (!widgetId) return null;

  return (
    <section data-testid="instagram-reels-section" className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-32">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <SectionHead kicker="Sui social" title="Ultimi reel." className="mb-0" />
        {instagramUrl && (
          <Reveal className="mb-2">
            <a
              href={instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="instagram-reels-link"
              className="group inline-flex items-center gap-2 font-oswald text-sm uppercase tracking-widest text-navy transition-colors duration-300 hover:text-orange"
            >
              <Instagram className="h-4 w-4" /> Seguici su Instagram
            </a>
          </Reveal>
        )}
      </div>

      <Reveal className="mt-14">
        <div className="border border-ink p-2 md:p-4">
          <iframe
            key={widgetId}
            src={`https://snapwidget.com/embed/${widgetId}`}
            title="Ultimi reel Instagram del movimento"
            data-testid="instagram-reels-iframe"
            className="snapwidget-widget w-full"
            style={{ border: "none", overflow: "hidden", minHeight: 420 }}
            allowtransparency="true"
            scrolling="no"
            loading="lazy"
          />
        </div>
      </Reveal>
    </section>
  );
};
